'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('@linaria/react');
var PropTypes = require('prop-types');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var _exp3 = function _exp3() {
  return function (_ref) {
    var color = _ref.color;
    return color;
  };
};
var StyledLoader = /*#__PURE__*/react.styled('div')({
  name: "StyledLoader",
  "class": "s1wd1xg1",
  propsAsIs: false,
  vars: {
    "s1wd1xg1-0": [_exp3()]
  }
});
({
  /** Color of the loading spinner */
  color: PropTypes__default["default"].string,
  /** Addiional classes to add to the loader component */
  className: PropTypes__default["default"].string
});
var Loader = function Loader(_ref2) {
  var color = _ref2.color,
    className = _ref2.className;
  return /*#__PURE__*/jsxRuntime.jsx("span", {
    className: className !== null && className !== void 0 ? className : undefined,
    children: /*#__PURE__*/jsxRuntime.jsx(StyledLoader, {
      "data-testid": "loader",
      color: color || 'gray'
    })
  });
};

exports["default"] = Loader;
